import { render } from "./HelloWorld.vue?vue&type=template&id=6cac83af&scoped=true&ts=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=6cac83af&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Azizi\\Documents\\Personal\\adeebxhannaslideshow\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cac83af"]])

export default __exports__